import moment from 'moment';

const filtersMappers = {
  stores: (order, stores) => stores.length === 0 || stores.some((storeId) => storeId === order.storeId),
  dispatchMethods: (order, dispatchMethods) =>
    dispatchMethods.length === 0 ||
    dispatchMethods.some((dispatchMethod) => dispatchMethod === order.dispatchMethod),
  orderAge: (order, age) => !age || moment(order.createdAt).isSameOrAfter(moment().subtract(age, 'h')),
  orderId: (order, id) => !id || parseInt(id) === parseInt(order.id)
};

export const checkOrderWithFilters = (order, filters) => {
  const isValid = Object.entries(filters).reduce((bool, [filterKey, filterValue]) => {
    if (!filtersMappers[filterKey](order, filterValue)) {
      return false;
    }
    return bool;
  }, true);
  return isValid;
};
